import Application from "../../Application";
import Area, { IArea } from "../../core/areas/Area";
import { IRouter } from "../../runtime/Router";
import CreateCaseLawDocumentInteractor from "../interactor/CreateCaseLawDocumentInteractor";
import FindCaseLawDocumentInteractor from "../interactor/FindCaseLawDocumentInteractor";
import GetAllCaseLawDocumentsInteractor from "../interactor/GetAllCaseLawDocumentsInteractor";
import ShowCaseLawDocumentDetailsInteractor from "../interactor/ShowCaseLawDocumentDetailsInteractor";
import ShowCaseLawDocumentsInteractor from "../interactor/ShowCaseLawDocumentsInteractor";
import CaseLawDocumentDetailsPage from "../ui/pages/CaseLawDocumentDetailsPage";
import CaseLawDocumentListPage from "../ui/pages/CaseLawDocumentListPage";
import AddItemsToCaseLawDocumentInteractor from "../interactor/AddItemsToCaseLawDocumentInteractor";
import GetCaseLawDocumentIndexesInteractor from "../interactor/GetCaseLawDocumentIndexesInteractor";
import GetNonAnonymisedCaseLawDocumentAttachmentsCountInteractor from "../interactor/GetNonAnonymisedCaseLawDocumentAttachmentsCountInteractor";

import UpdateCaseLawDocumentInteractor from "../interactor/UpdateCaseLawDocumentInteractor";
import AddCourtCasesToCaseLawDocumentInteractor from "../interactor/AddCourtCasesToCaseLawDocumentInteractor";
import GetAllCaseLawDocumentAttachmentsInteractor from "../interactor/attachments/GetAllCaseLawDocumentAttachmentsInteractor";
import CreateAttachmentInteractor from "../interactor/attachments/CreateAttachmentInteractor";
import CreateAttachmentFileInteractor from "../interactor/attachments/CreateAttachmentFileInteractor";
import RemoveCaseLawDocumentAttachmentInteractor from "../interactor/attachments/RemoveCaseLawDocumentAttachment";
import RevertCaseLawDocumentStatusInteractor from "../interactor/RevertCaseLawDocumentStatusInteractor";
import PublishCaseLawDocumentInteractor from "../interactor/PublishCaseLawDocumentInteractor";
import GetCaseLawDocumentInteractor from "../interactor/GetCaseLawDocumentInteractor";
import UpdateCaseLawDocumentTypeInteractor from "../interactor/UpdateCaseLawDocumentTypeInteractor";
import CaseLawDocumentCreationPage from "../ui/pages/CaseLawDocumentCreationPage";
import ShowCaseLawDocumentCreationInteractor from "../interactor/ShowCaseLawDocumentCreationInteractor";
import CaseLawDocumentUpdatingPage from "../ui/pages/CaseLawDocumentUpdatingPage";
import ShowCaseLawDocumentUpdatingInteractor from "../interactor/ShowCaseLawDocumentUpdatingInteractor";
import FindCourtCaseDetailsInteractor from "../interactor/FindCourtCaseDetailsInteractor";
import ArchiveCaseLawDocumentInteractor from "../interactor/ArchiveCaseLawDocumentInteractor";
import GetInvalidatedCaseLawDocumentsInteractor from "../interactor/GetInvalidatedCaseLawDocumentsInteractor";
import GetAllCourtCaseConnectionTypesInteractor from "../interactor/GetAllCourtCaseConnectionTypesInteractor";
import CreateCourtCaseConnectionTypeInteractor from "../interactor/CreateCourtCaseConnectionTypeInteractor";
import UpdateCourtCaseConnectionTypeInteractor from "../interactor/UpdateCourtCaseConnectionTypeInteractor";
import ShowCourtCaseConnectionTypesInteractor from "../interactor/ShowCourtCaseConnectionTypesInteractor";
import CourtCaseConnectionTypePage from "../ui/pages/CourtCaseConnectionTypePage";
import DeleteCaseLawDocumentInteractor from "../interactor/DeleteCaseLawDocumentInteractor";
import FindCourtCaseWithAllDecisionsInteractor from "../interactor/FindCourtCaseWithAllDecisionsInteractor";

export default class CaseLawDocumentsArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }

  private registerModules() {
    const container = this.application.container;
    container.registerInteractor(
      "getAllCaseLawDocuments",
      GetAllCaseLawDocumentsInteractor
    );

    container.registerInteractor(
      "createCaseLawDocument",
      CreateCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "showCaseLawDocuments",
      ShowCaseLawDocumentsInteractor
    );

    container.registerInteractor(
      "findCaseLawDocument",
      FindCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "showCaseLawDocumentDetails",
      ShowCaseLawDocumentDetailsInteractor
    );

    container.registerInteractor(
      "addItemsToCaseLawDocument",
      AddItemsToCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "getCaseLawDocumentIndexes",
      GetCaseLawDocumentIndexesInteractor
    );

    container.registerInteractor(
      "addCourtCasesToCaseLawDocument",
      AddCourtCasesToCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "getNonAnonymisedCaseLawDocumentAttachmentsCount",
      GetNonAnonymisedCaseLawDocumentAttachmentsCountInteractor
    );
    container.registerInteractor(
      "updateCaseLawDocument",
      UpdateCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "getAllCaseLawDocumentAttachments",
      GetAllCaseLawDocumentAttachmentsInteractor
    );
    container.registerInteractor(
      "createAttachment",
      CreateAttachmentInteractor
    );
    container.registerInteractor(
      "createAttachmentFile",
      CreateAttachmentFileInteractor
    );
    container.registerInteractor(
      "removeCaseLawDocumentAttachment",
      RemoveCaseLawDocumentAttachmentInteractor
    );
    container.registerInteractor(
      "revertCaseLawDocumentStatus",
      RevertCaseLawDocumentStatusInteractor
    );
    container.registerInteractor(
      "publishCaseLawDocument",
      PublishCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "getCaseLawDocument",
      GetCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "updateCaseLawDocumentType",
      UpdateCaseLawDocumentTypeInteractor
    );
    container.registerInteractor(
      "showCaseLawDocumentCreation",
      ShowCaseLawDocumentCreationInteractor
    );
    container.registerInteractor(
      "showCaseLawDocumentUpdating",
      ShowCaseLawDocumentUpdatingInteractor
    );
    container.registerInteractor(
      "findCourtCaseDetails",
      FindCourtCaseDetailsInteractor
    );
    container.registerInteractor(
      "archiveCaseLawDocument",
      ArchiveCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "getInvalidatedCaseLawDocuments",
      GetInvalidatedCaseLawDocumentsInteractor
    );
    container.registerInteractor(
      "getAllCourtCaseConnectionTypes",
      GetAllCourtCaseConnectionTypesInteractor
    );
    container.registerInteractor(
      "createCourtCaseConnectionType",
      CreateCourtCaseConnectionTypeInteractor
    );
    container.registerInteractor(
      "updateCourtCaseConnectionType",
      UpdateCourtCaseConnectionTypeInteractor
    );
    container.registerInteractor(
      "showCourtCaseConnectionTypes",
      ShowCourtCaseConnectionTypesInteractor
    );
    container.registerInteractor(
      "deleteCaseLawDocument",
      DeleteCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "findCourtCaseWithAllDecisions",
      FindCourtCaseWithAllDecisionsInteractor
    );
  }
  register(params: any) {
    this.registerModules();
    this.router.registerRoutes(
      {
        path: "/case-law-documents",
        page: this.createPage({
          Page: CaseLawDocumentListPage,
          action: this.showCaseLawDocumentsPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/case-law-documents/:id/details",
        page: this.createPage({
          Page: CaseLawDocumentDetailsPage,
          action: this.showCaseLawDocumentDetailsPage.bind(this)
        }),
        options: {
          secure: true
        }
      },

      {
        path: "/case-law-documents/new",
        page: this.createPage({
          Page: CaseLawDocumentCreationPage,
          action: this.showCaseLawCreationPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/case-law-documents/:id/update",
        page: this.createPage({
          Page: CaseLawDocumentUpdatingPage,
          action: this.showCaseLawDocumentUpdatingPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/court-case-connection-type",
        page: this.createPage({
          Page: CourtCaseConnectionTypePage,
          action: this.showCourtCaseConnectionTypes.bind(this)
        }),
        options: {
          secure: true
        }
      }
    );
  }

  public showCaseLawDocumentsPage() {
    return this.application.container
      .resolve<ShowCaseLawDocumentsInteractor>("showCaseLawDocuments")
      .execute();
  }
  public showCaseLawCreationPage() {
    return this.application.container
      .resolve<ShowCaseLawDocumentCreationInteractor>(
        "showCaseLawDocumentCreation"
      )
      .execute();
  }
  public showCaseLawDocumentUpdatingPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowCaseLawDocumentUpdatingInteractor>(
        "showCaseLawDocumentUpdating"
      )
      .execute(Number.parseInt(id, 10));
  }
  public showCaseLawDocumentDetailsPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowCaseLawDocumentDetailsInteractor>(
        "showCaseLawDocumentDetails"
      )
      .execute(Number.parseInt(id, 10));
  }
  public showCourtCaseConnectionTypes() {
    return this.application.container
      .resolve<ShowCourtCaseConnectionTypesInteractor>(
        "showCourtCaseConnectionTypes"
      )
      .execute();
  }
}
